function createScript(url) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    return script;
}

function createLink(url) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = url;
    return link;
}

function ResourceInjector($q) {
    this.$q = $q;
}

ResourceInjector.prototype.isScriptInjected = function (url, el) {
    return !!(el || document.head).querySelector(`[src="${url}"]`);
};

ResourceInjector.prototype.isStylesheetInjected = function (url, el) {
    return !!(el || document.head).querySelector(`[href="${url}"]`);
};

ResourceInjector.prototype.injectScript = function (url) {
    return this._injectResource(url, createScript, this.isScriptInjected);
};

ResourceInjector.prototype.injectStylesheet = function (url) {
    return this._injectResource(url, createLink, this.isStylesheetInjected);
};

ResourceInjector.prototype.injectScripts = function (urls) {
    return this.$q.all(urls.map(this.injectScript.bind(this)));
};

ResourceInjector.prototype.injectStylesheets = function (urls) {
    return this.$q.all(urls.map(this.injectStylesheet.bind(this)));
};

ResourceInjector.prototype._injectResource = function (url, buildAssetFn, isInjectedFn) {
    const deferred = this.$q.defer();
    if (!isInjectedFn(url)) {
        const assetEl = buildAssetFn(url);
        assetEl.onload = deferred.resolve;
        assetEl.onerror = deferred.reject;
        document.head.appendChild(assetEl);
    } else {
        deferred.resolve();
    }

    return deferred.promise;
};

ResourceInjector.prototype.removeHeadSrcInjection = function (url) {
    const assetEl = document.head.querySelector(`[src="${url}"]`);
    if (assetEl) {
        document.head.removeChild(assetEl);
    }

    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
};

module.exports = function ($q) {
    return new ResourceInjector($q);
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/resources/resource-injector-factory.js
 **/